export default {
    SET_CHECKED: (state, payload) => {
        state.checked = payload;
    },
    SET_USER: (state, payload) => {
        state.user = payload;
        if (payload.navs && payload.navs.length) {
            for (let i = 0; i < payload.navs.length; i++) {
                state.navs[payload.navs[i].component] = true;
            }
        }
    },
    SET_newOrder: (state, payload) => {
        state.newOrder = payload;
    },
    OPEN_MODAL: (state, payload) => {
        state.modalName = payload;
    },
    SET_VALUE: (state, payload) => {
        state.valueSelected = payload;
    },
    SET_LAST_UPDATE: (state, payload) => {
        state.lastUpdate = payload;
    },
    SET_LANGUAGES: (state, payload) => {
        state.languages = payload;
    },
    SET_LANGUAGE: (state, payload) => {
        state.language = payload;
    },
    SET_LOCATION: (state, payload) => {
        state.location = payload;
    }
}